import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-treatment-plan',
  templateUrl: './treatment-plan.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: GeneralConsultTreatmentPlanComponent, multi: true }
  ]
})
export class GeneralConsultTreatmentPlanComponent extends BaseValueAccessor<string>{
  readonly screen = generalConsultDetailConstants.treatmentPlan;
  @Input() turn = -1;
  @Input() readonly = false;
  expandSection = true;
}
